import axios from "axios";
import {
  linkRequested,
  linkRequestSucceeded,
  linkRequestFailed,
} from "../slices/GetAllLinksSlice";
const selectedCountry = localStorage.getItem("selectedCountry");

const apiUrl = `${
  process.env.REACT_APP_BASE_API_URL
}/api/Menu/GetLinksByCountry?country=${encodeURIComponent(selectedCountry)}`;

const ApiKey = process.env.REACT_APP_BASE_API_KEY;

export const GetLinksByCountry = () => async (dispatch) => {
  try {
    dispatch(linkRequested());

    const axiosConfig = {
      headers: {
        ApiKey: ApiKey,
        "Content-Type": "application/json",
      },
    };
    const response = await axios.get(apiUrl, axiosConfig);

    dispatch(linkRequestSucceeded(response.data));
  } catch (error) {
    dispatch(linkRequestFailed(error.message));
  }
};
